import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-ea-black flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center">
            <i className="ri-loader-4-line text-ea-blue text-3xl animate-spin"></i>
          </div>
          <p className="text-ea-gray text-sm">Loading your account...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signup" state={{ from: location, tab: 'login' }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
